import { ref, readonly } from 'vue';

const isLoadSymbolOnlyEnabled = ref(false);

function setIsLoadSymbolOnlyEnabled(isLoadSymbolOnlyNowEnabled: boolean) {
  isLoadSymbolOnlyEnabled.value = isLoadSymbolOnlyNowEnabled;
}

export function useLoadSymbolOnly() {
  return {
    isLoadSymbolOnlyEnabled: readonly(isLoadSymbolOnlyEnabled),
    setIsLoadSymbolOnlyEnabled
  };
}
